export * as Themes from './themes';
export * as Colors from './colors';

import MessagesFr from './resources/messages.json';
import {Messages as MasterMessages} from '../master';

export const Messages = {...MasterMessages, ...MessagesFr};
